import { ReactNode } from 'react'
import { Trash02Icon } from '@systemeio/icons'
import { Transforms } from 'slate'
import {
  ReactEditor,
  RenderElementProps,
  useFocused,
  useSelected,
  useSlateStatic,
} from 'slate-react'
import { twMerge } from 'tailwind-merge'
import { ImageElement as ImageElementType } from 'modules/community/types/custom-editor'

export interface CustomImageProps extends RenderElementProps {
  element: ImageElementType
}

export const ImageElement = ({ attributes, children, element }: CustomImageProps): ReactNode => {
  const editor = useSlateStatic()
  const selected = useSelected()
  const focused = useFocused()
  const path = ReactEditor.findPath(editor, element)

  return (
    <div {...attributes}>
      <div contentEditable={false} className="relative">
        <img
          alt="image"
          src={element.url}
          className={twMerge(
            'mx-auto block max-w-full',
            selected && focused ? 'shadow-2' : 'shadow-none',
          )}
        />
        <Trash02Icon
          onClick={() => Transforms.removeNodes(editor, { at: path })}
          className={twMerge(
            `absolute top-0 right-2/3 cursor-pointer text-text-secondary hover:text-text-error`,
            selected && focused ? 'inline' : 'hidden',
          )}
          width="14px"
        />
      </div>
      {children}
    </div>
  )
}
